module.exports = __webpack_public_path__ + "fonts/Inter-900-cyrillic79.de93fdc.woff2";